document.addEventListener('DOMContentLoaded', () => {
  const addToCartButton = document.querySelector('#button-wrap');
  const productContainer = document.querySelector('.product-actions-wrapper');
  const add_to_cart_btn = document.querySelector('.add_to_cart_btn');

  // Function to check if the button is in view or not
  function handleScroll() {

     if (!addToCartButton || !productContainer) return; // safeguard
      const buttonRect = add_to_cart_btn.getBoundingClientRect(); // Get the current position of the button relative to viewport
      const containerRect = productContainer.getBoundingClientRect(); // Get container's position relative to viewport

      // When the button goes out of view (below the top of the viewport)
      if (buttonRect.top <= 0 || containerRect.bottom <= buttonRect.height) {
          addToCartButton.classList.add('active');
          productContainer.classList.add('stickyactive');
      } else {
          addToCartButton.classList.remove('active');
        productContainer.classList.remove('stickyactive');
      }
  }

  // Listen for the scroll event and trigger the handleScroll function
  window.addEventListener('scroll', handleScroll);

  // Trigger the function on page load in case the page is already scrolled
  handleScroll();
  
});
function setEqualHeightInSlider(sliderSelector, targetSelector) {
  var maxHeight = 0;

  // Reset heights first
  jQuery(sliderSelector).find(targetSelector).css('height', 'auto');

  // Find max height among visible slides
  jQuery(sliderSelector).find(targetSelector).each(function () {
    var thisHeight = jQuery(this).outerHeight();
    if (thisHeight > maxHeight) {
      maxHeight = thisHeight;
    }
  });

  // Apply the max height
  jQuery(sliderSelector).find(targetSelector).height(maxHeight);
}
jQuery('.home-slider-products').on('init reInit afterChange', function () {
  setEqualHeightInSlider('.home-slider-products', '.equal-height');  
});

jQuery(window).on('load resize', function () {  
  setEqualHeightInSlider('.home-slider-products', '.equal-height');
  setEqualHeightInSlider('.product-grid-container .product-grid', '.equal-height');
});
$(document).ready(function(){
  
  $('.tolstoy-carousel-container').hide();
  setTimeout(function() {
    $('.tolstoy-carousel-videos-container').slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 991,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 640,
          settings: { slidesToShow: 1 }
        }
      ]
    });    
  }, 2000); // wait 300ms to ensure HTML is rendered
  $('.tolstoy-carousel-container').show();
  $('#Slider-tag-blog-post').hide();
  setTimeout(function() {
    $('#Slider-tag-blog-post').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1439,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 991,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 640,
          settings: { slidesToShow: 1 }
        }
      ]
    });    
  }, 1000); // wait 300ms to ensure HTML is rendered
  $('#Slider-tag-blog-post').show();

 

if(jQuery(".product-form__input.product-form__input--dropdown").length > 1){
    jQuery(".product__info-container").addClass("label-block");
}
//   var viewport = $(window),
//   setVisible = function (e) {
//       var viewportTop = viewport.scrollTop(),
//           viewportBottom = viewport.scrollTop() + viewport.height() - 300;
//       $('.animate.animate--zoom-in').each(function () {
//           var self = $(this),
//               top = self.offset().top,
//               bottom = top + self.height(),
//               topOnScreen = top >= viewportTop && top <= viewportBottom,
//               bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
//               elemVisible = topOnScreen || bottomOnScreen;
//           self.addClass('animated', elemVisible);
//       });
//   };
// viewport.scroll(setVisible);
// setVisible();



  
  // $(".image-content-row .img-block .clickImg").click(function(){
  //        $(this).parent().toggleClass("animate");
  //  })

   $('.key-notes-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
  });

   $('.home-slider-products').slick({
    infinite: false,
    centerMode: false,
    centerPadding: '30px',
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
     responsive: [
        {
          breakpoint: 1439,
          settings: {
            slidesToShow: 3,
          }
        },
       {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        },
       {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
          }
        }
    ]
  });

  $('.ugc-slider-main').slick({
    infinite: false,
    centerMode: false,
    centerPadding: '30px',
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
     responsive: [
        {
          breakpoint: 1439,
          settings: {
            slidesToShow: 3,
          }
        },
       {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        },
       {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
          }
        }
    ]
  });
  
  $('.layers-well-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    settings: 'unslick',
    responsive: [
        {
            breakpoint: 3840,
            settings: 'unslick'
        },
        {
            breakpoint: 992,
            settings: 'unslick'
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
    ]
  });
  

  
$('#home-slider').on('init', function (event, slick) {
    toggleDots(slick); // Call the function to toggle dots on init
  });

  // Re-check when slides change dynamically, if applicable
  $('#home-slider').on('afterChange', function (event, slick) {
    toggleDots(slick); // Call the function to toggle dots after slide changes
  });

  $home_slick_slider = $('#home-slider');
settings = {
  draggable: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: true,
    fade: true,
    speed: 2500,
    infinite: true
};
$home_slick_slider.slick(settings);

$('#about-slider').on('init', function (event, slick) {
    toggleDots(slick); // Call the function to toggle dots on init
  });

  // Re-check when slides change dynamically, if applicable
  $('#about-slider').on('afterChange', function (event, slick) {
    toggleDots(slick); // Call the function to toggle dots after slide changes
  });

  $about_slick_slider = $('#about-slider');
aboutsettings = {
  draggable: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: true,
    fade: true,
    speed: 2500,
    infinite: true
};
$about_slick_slider.slick(aboutsettings);

  // Function to show/hide dots
  function toggleDots(slick) {
    // Get the total number of slides
    var totalSlides = slick.$slides.length;
    console.log('Total slides:', totalSlides); // Debugging

    // Show/hide dots based on slide count
    if (totalSlides > 1) {
      $('#home-slider .slick-dots').show();
    } else {
      $('#home-slider .slick-dots').hide();
    }
  }

    $announcement_slick_slider = $('.announcement-slider');
settings_announcement = {
  draggable: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    fade: true,
    speed: 2500,
    infinite: true
};
$announcement_slick_slider.slick(settings_announcement);
  $(".ingredients .h3").click(function(){
       $(this).toggleClass("active");
       $(".ingredients .description").slideToggle();
  })

  

  matchHeight.init();
  

jQuery('.product-card').each(function() {
    var $card = jQuery(this);
    var $firstVisibleVariant = $card.find('.variant-option').not('.hidden').first();

    if ($firstVisibleVariant.length) {
      selectVariant($firstVisibleVariant[0]); // Pass native DOM element to your existing function
    }
  });

// }


  // Default variant dropdown
  jQuery(".product-form__input--dropdown select").on("change", function(){
    var selectedVariantTitle = jQuery(this).val();

    jQuery('.variant-grid .variant-option').each(function () {
      var variantTitle = jQuery(this).data('variant-title');  
      var variantPrice = jQuery(this).data('price');  
      
      if(selectedVariantTitle == variantTitle){
        jQuery('.variant-grid .variant-option').removeClass('active');
        jQuery(this).addClass('active');

        jQuery('.vprice').text(variantPrice);
      }          
    });        
  });



// Header Menu on Hover
const detailsElement = document.getElementById('Details-HeaderMenu-1');
const summaryElement = document.getElementById('HeaderMenu-shop');

summaryElement.addEventListener('mouseenter', () => {
  detailsElement.setAttribute('open', 'true');
  summaryElement.setAttribute('aria-expanded', 'true');
});

summaryElement.addEventListener('mouseleave', () => {
  detailsElement.removeAttribute('open', 'false');
  summaryElement.setAttribute('aria-expanded', 'false');
});

 })

 
 var matchHeight = function () {
  function init() {
      eventListeners();
      matchHeight();
  }

  function eventListeners() {
      jQuery(window).on('resize', function () {
          matchHeight();
      });
  }

  function matchHeight() {
      var groupName = jQuery('[data-match-height]');
      var groupHeights = [];

      groupName.css('min-height', 'auto');

      groupName.each(function () {
          groupHeights.push(jQuery(this).outerHeight());
      });

      var maxHeight = Math.max.apply(null, groupHeights);
      groupName.css('min-height', maxHeight);
  };

  return {
      init: init
  };

}();



(function (jQuery) {
    jQuery.fn.visible = function (partial) {
      var jQueryt = jQuery(this),
        jQueryw = jQuery(window),
        viewTop = jQueryw.scrollTop(),
        viewBottom = viewTop + jQueryw.height(),
        _top = jQueryt.offset().top + 300,
        _bottom = _top + jQueryt.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;
  
      return compareBottom <= viewBottom && compareTop >= viewTop;
    };
  })(jQuery);
  
  jQuery(window).scroll(function (event) {
    jQuery(".image-content-row").each(function (i, el) {
      var el = jQuery(el);
      if (el.visible(true)) {
        el.addClass("animated");
      } else {
        // el.removeClass("animated");
      }
    });

    
  });

jQuery(document).on('click', '.has-submenu details > summary', function () {
    //console.log('menu click');
  const $currentDetails = jQuery(this).parent().parent("li");
  //console.log("$currentDetails", $currentDetails);

  $currentDetails.siblings('li').each(function () {
      //console.log("find ul");
    if (jQuery(this).children("details").attr('open')) {
        //console.log("has open");
      jQuery(this).children("details").removeAttr('open').removeClass('menu-opening');
        //console.log("remove open");
      jQuery(this).find('summary').attr('aria-expanded', 'false');
    }
  });
 
 
});

function truncateParagraph(selector, wordLimit) {
    const paragraph = jQuery(selector).first(); // Target only the first paragraph
    if (paragraph.length === 0) return; // ✅ Exit if no element found

    const fullHtml = paragraph.html()?.trim(); // Use optional chaining
    if (!fullHtml) return; // ✅ Exit if empty

    const tempDiv = jQuery('<div>').html(fullHtml); 
    const words = tempDiv.text().trim().split(/\s+/);

    if (words.length > wordLimit) {
        const truncatedText = words.slice(0, wordLimit).join(" ");
        const truncatedHtml = `${truncatedText} ...`;
        paragraph.data("full-html", fullHtml);
        paragraph.html(truncatedHtml);
    }
}

// Initialize buttons
jQuery("#hider").hide();
jQuery("#shower").hide();

// Apply truncation to the first paragraph
const wordLimit = 75; // Define word limit
truncateParagraph(".collection-bottom-div .content > p:first", wordLimit);

// Count paragraphs
const paragraphCount = jQuery(".collection-bottom-div .content > p").length;

// Show "shower" button only if more content exists
if (paragraphCount > 1 || jQuery(".collection-bottom-div .content > p:first").text().trim().split(/\s+/).length > wordLimit) {
    jQuery("#shower").show();
}

// Handle the "hider" button click
jQuery("#hider").click(function () {
    // Truncate the first paragraph again
    truncateParagraph(".collection-bottom-div .content > p:first", wordLimit);

    // Hide all other elements except the first paragraph
    jQuery(".collection-bottom-div .content > *").not(":first").hide();

    // Toggle button visibility
    jQuery("#hider").hide();
    jQuery("#shower").show();
});

// Handle the "shower" button click
jQuery("#shower").click(function () {
    // Show the full content of the first paragraph
    const firstParagraph = jQuery(".collection-bottom-div .content > p:first");
    firstParagraph.html(firstParagraph.data("full-html")); // Restore the full content

    // Show all other elements
    jQuery(".collection-bottom-div .content > *").show();

    // Toggle button visibility
    jQuery("#shower").hide();
    jQuery("#hider").show();
});

// Initially hide all elements except the truncated first paragraph
jQuery(".collection-bottom-div .content > *").not(":first").hide();

function selectVariant(button) {
  const card = button.closest('.product-card');
  const image = card.querySelector('.front-product-image');
  const hoverImage = card.querySelector('.hover-product-image');
  const price = card.querySelector('.price');
  const compare_at_price = card.querySelector('.compare_at_price');
  const animateImage = card.querySelector('#animate-img');
  const hiddenInput = card.querySelector('.product-variant-id');

  // Pre-selects a product variant when the page loads
  card.querySelectorAll('.variant-option').forEach(btn => btn.classList.remove('active'));
  button.classList.add('active');

  // Update image
  const newImage = button.getAttribute('data-image');
  if (newImage) {
    image.src = newImage;
  }

  if(hoverImage){
   const newhoverImage = button.getAttribute('data-hover-image');
  if (newhoverImage) {
    hoverImage.src = newhoverImage;
  }
  }

  // Update price
  price.innerText = button.getAttribute('data-price');

  // Update compare_at_price
  if (compare_at_price) {
    compare_at_price.innerText = button.getAttribute('data-compare-price');
  }

  // Update hidden input for add to cart
  hiddenInput.value = button.getAttribute('data-variant-id');

  const newAnimateImage = button.getAttribute('data-animate-image');
  if (newAnimateImage && animateImage) {
    animateImage.src = newAnimateImage;
  }
if (card.classList.contains('animated')) {
  // Hide animate image smoothly
  if (animateImage) {
    animateImage.style.opacity = '0';
    animateImage.style.transition = 'opacity 0.3s ease-in-out';
    animateImage.style.transform = 'translate(-50%,-50%) scale(0)';
  }

  // Remove animated class to reset animation
  card.classList.remove('animated');
  void card.offsetWidth; // Force reflow

  // Re-show image and re-add class after delay
  setTimeout(() => {
    if (animateImage) {
      animateImage.style.opacity = '1';
      animateImage.style.transition = 'all 1s linear'; 
      animateImage.style.transform = 'translate(-50%,-50%) scale(1)';
    }
    card.classList.add('animated');
  }, 300); // Delay should match or be slightly more than transition time
}
}


function selectVariantProduct(button) {
  const card = button.closest('.template-product .product');
  const image = card.querySelector('.product-image');
  const price = card.querySelector('.vprice');
  const topPrice = card.querySelector('.price-item--regular');
  const hiddenInput = card.querySelector('.product-variant-id');

  // Pre-selects a product variant when the page loads
  card.querySelectorAll('.variant-option').forEach(btn => btn.classList.remove('active'));
  button.classList.add('active');
  

  // Update image
  const newImage = button.getAttribute('data-image');
  if (newImage) {
    // image.src = newImage; // desktop
    image.setAttribute('srcset', newImage); // mobile
  }

  // Update price
  price.innerText = button.getAttribute('data-price');
  topPrice.innerText = button.getAttribute('data-price');

  // Update hidden input for add to cart
  hiddenInput.value = button.getAttribute('data-variant-id');

  // Trigger default variant dropdown
  const select = card.querySelector('select[name="id"]');
  const variantTitle = button.getAttribute('data-variant-title');
  select.value = variantTitle;
  // select.dispatchEvent(new Event('change', { bubbles: true }));

  // Instead of dispatching "change" which triggers scroll, call Shopify's selectVariant manually (if defined)
  if (typeof Shopify !== "undefined" && Shopify.Product && typeof Shopify.Product.prototype.selectVariant === "function") {
    const form = card.closest('form');
    if (form && form.product) {
      form.product.selectVariant(variantId); // This avoids default scroll
    }
  } else {
    // As fallback, trigger change without jump
    const handler = select.onchange;
    if (typeof handler === "function") {
      handler.call(select);
    }
  }
}
